import { render } from "./History.vue?vue&type=template&id=bee95f8c&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=bee95f8c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1463868861/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee95f8c"]])

export default __exports__